import { Observable } from 'rxjs';
import { CreateQuestionnaireRequest, PagedQuestionnaireResponse, Questionnaire, QuestionnairesApi, SingleQuestionnaireResponse } from 'src/app/hickory-api';
import { getPage } from './data/PageHelper';
import { getSingle } from './data/SingleHelper';
import { mockHandler } from '../mock.handler';

export class MockQuestionnairesApi extends QuestionnairesApi {

  hiltonQuestionnaires: Questionnaire[] = [{
    name: 'Mock Severity Assessment',
    questions: [
      {
        id: 'id.hilton.assessment.questions.seriousillness',
        text: 'Was there serious illness, injury, or loss of life?',
        sequence: 1,
        options: [
          {
            id: 'id.hilton.assessment.responses.yesno.yes',
            text: 'Yes',
            sequence: 1
          },
          {
            id: 'id.hilton.assessment.responses.yesno.no',
            text: 'No',
            sequence: 2
          }
        ]
      },
      {
        id: 'id.hilton.assessment.questions.propertydamage',
        text: 'Was there significant damage or loss?',
        sequence: 2,
        options: [
          {
            id: 'id.hilton.assessment.responses.yesno.yes',
            text: 'Yes',
            sequence: 1
          },
          {
            id: 'id.hilton.assessment.responses.yesno.no',
            text: 'No',
            sequence: 2
          }
        ]
      },
      {
        id: 'id.hilton.assessment.questions.businessdisruption',
        text: 'Was or do you expect there to be a significant business disruption?',
        sequence: 3,
        options: [
          {
            id: 'id.hilton.assessment.responses.yesno.yes',
            text: 'Yes',
            sequence: 1
          },
          {
            id: 'id.hilton.assessment.responses.yesno.no',
            text: 'No',
            sequence: 2
          }
        ]
      },
      {
        id: 'id.hilton.assessment.questions.evacuation',
        text: 'Was there a partial or full evacuation of the property?',
        sequence: 4,
        options: [
          {
            id: 'id.hilton.assessment.responses.yesno.yes',
            text: 'Yes',
            sequence: 1
          },
          {
            id: 'id.hilton.assessment.responses.yesno.no',
            text: 'No',
            sequence: 2
          }
        ]
      },
      {
        id: 'id.hilton.assessment.questions.mediainterest',
        text: 'Were there or do you anticipate media inquiries or external interest?',
        sequence: 5,
        options: [
          {
            id: 'id.hilton.assessment.responses.yesno.yes',
            text: 'Yes',
            sequence: 1
          },
          {
            id: 'id.hilton.assessment.responses.yesno.no',
            text: 'No',
            sequence: 2
          }
        ]
      }
    ]
  }];

  createQuestionnaire(body: CreateQuestionnaireRequest): Observable<any> {
    const response: SingleQuestionnaireResponse = getSingle(body);
    return mockHandler(response);
  }

  getQuestionnaires(page?: number, pageSize?: number): Observable<any> {
    const response: PagedQuestionnaireResponse = getPage(this.hiltonQuestionnaires, page, pageSize);
    return mockHandler(response);
  }
}
